


export type BillAssignmentTargetType = 'Private' | 'CostCentre';

export const BillAssignmentTargetType = {
    Private: 'Private' as BillAssignmentTargetType,
    CostCentre: 'CostCentre' as BillAssignmentTargetType
};

